//Angular
import { Component, Injectable } from "@angular/core";

//Components
import { HomeComponent } from "../../components/cms/homepage/sys/home.component";
import { FaqComponent } from "../../components/cms/page/sys/faq.component";
import { CookiePolicyComponent } from "../../components/cms/page/sys/cookie-policy.component";
import { PrivacyPolicyComponent } from "../../components/cms/page/sys/privacy-policy.component";
import { PurchaseConditionComponent } from "../../components/cms/page/sys/purchase-condition.component";
import { InfoRequestComponent  } from "../../components/cms/page/sys/info-request.component";
import { UserLoginComponent } from "../../components/settings/user/sys/user-login.component";
import { UserPasswordComponent } from "../../components/settings/user/sys/user-password.component";
import { RegisterComponent } from "../../components/settings/user/sys/register.component";
import { CmsPageComponent } from "../../components/cms/page/sys/cms-page.component";
import { CategoryComponent } from "../../components/inventory/category/sys/category.component";
import { ProductDetailsComponent } from "../../components/inventory/product/sys/product-details.component";
import { ProductPageListComponent } from "../../components/inventory/product/sys/product-page-list.component";
import { PromotionsComponent } from "../../components/inventory/product/sys/promotions.component";
import { ArticleComponent } from "../../components/cms/article/sys/news-page.component";
import { OtherProductComponent } from "../../components/inventory/product/sys/other-product.component";
import { BlogPageComponent } from "../../components/cms/article/sys/blog-page.component";
import { ArticleCategoryComponent } from "../../components/cms/article/sys/article-category.component";
import { ClientAreaHomeComponent } from "../../components/settings/client-area/sys/client-area-home.component";
import { ClientAreaOrderListComponent } from "../../components/document/sys/client-area-order-list.component";
import { ClientAreaProfileComponent } from "../../components/settings/client-area/sys/client-area-profile.component";
import { CartComponent } from "../../components/inventory/shopping-cart/sys/cart.component";
import { CartCashComponent } from "../../components/inventory/shopping-cart/sys/cart-cash.component";
import { CartSubmittedComponent } from "../../components/inventory/shopping-cart/sys/cart-submitted.component";
import { CartEmptyPageComponent } from "../../components/core/sys/cart-empty-page.component";
import { ClientAreaOrderDetailsComponent } from '../../components/settings/client-area/sys/client-area-order-details.component';
import { ClientAreaCatalogPrivateComponent } from '../../components/settings/client-area/sys/client-area-catalog-private.component';
import { RoutesService } from "../../services/core/routes.service";
import { RegistrationConfirmationComponent } from "../../components/settings/user/sys/registration-confirmation.component";
import { OfflinePageComponent } from "../../components/core/sys/offline-page.component";
import { PaymentConfirmationComponent } from "../../components/settings/client-area/sys/payment-confirmation.component";
import { PaymentUnicreditConfirmationComponent } from "../../components/settings/client-area/sys/payment-unicredit-confirmation.component";
import { PaymentNexiConfirmationComponent } from "../../components/settings/client-area/sys/payment-nexi-confirmation.component";
import { PaymentBancaSellaConfirmationComponent } from "../../components/settings/client-area/sys/payment-banca-sella-confirmation.component";
import { NotFoundPageComponent } from "../../components/core/sys/not-found-page.component";
import { SearchComponent } from "../../components/cms/header/widget/search.component";
import { ClientAreaInvoicesComponent } from "../../components/settings/client-area/sys/client-area-invoices.component";
import { NewsletterConfirmationPageComponent } from './../../components/cms/page/sys/newsletter-confirmation-page.component';
import { NewsletterPageComponent } from './../../components/cms/page/sys/newsletter-page.component';
import { RegistrationConfirmationPageComponent } from './../../components/settings/user/sys/registration-complete.component';
import { QuickRegistrationComponent } from "../../components/settings/user/sys/quick-registration.component";

@Injectable()
export class SysConfig {

  constructor() {
  }    

    static getComponentByName(componentName) {
        let component: any;

        switch (componentName) {
            case 'HomeComponent': component = HomeComponent; break;
            case 'FaqComponent': component = FaqComponent; break;
            case 'ClientAreaHomeComponent': component = ClientAreaHomeComponent; break;
            case 'PrivacyPolicyComponent': component = PrivacyPolicyComponent; break;
            case 'CookiePolicyComponent': component = CookiePolicyComponent; break;
            case 'PurchaseConditionComponent': component = PurchaseConditionComponent; break;
            case 'InfoRequestComponent': component = InfoRequestComponent; break;
            case 'UserLoginComponent': component = UserLoginComponent; break;
            case 'UserPasswordComponent': component = UserPasswordComponent; break;
            case 'RegisterComponent': component = RegisterComponent; break;
            case 'CmsPageComponent': component = CmsPageComponent; break;
            case 'CategoryComponent': component = CategoryComponent; break;
            case 'ProductDetailsComponent': component = ProductDetailsComponent; break;
            case 'ProductPageListComponent': component = ProductPageListComponent; break;
            case 'PromotionsComponent': component = PromotionsComponent; break;
            case 'ArticleComponent': component = ArticleComponent; break;
            case 'OtherProductComponent': component = OtherProductComponent; break;
            case 'BlogPageComponent': component = BlogPageComponent; break;
            case 'ArticleCategoryComponent': component = ArticleCategoryComponent; break;
            case 'ClientAreaOrderListComponent': component = ClientAreaOrderListComponent; break;
            case 'ClientAreaInvoicesComponent': component = ClientAreaInvoicesComponent; break;            
            case 'ClientAreaProfileComponent': component = ClientAreaProfileComponent; break;
            case 'CartComponent': component = CartComponent; break;
            case 'CartCashComponent': component = CartCashComponent; break;
            case 'CartSubmittedComponent': component = CartSubmittedComponent; break;
            case 'CartEmptyPageComponent': component = CartEmptyPageComponent; break;
            case 'ClientAreaOrderDetailsComponent': component = ClientAreaOrderDetailsComponent; break;
            case 'ClientAreaCatalogPrivateComponent': component = ClientAreaCatalogPrivateComponent; break;
            case 'RegistrationConfirmationComponent': component = RegistrationConfirmationComponent; break;
            case 'PaymentConfirmationComponent' : component = PaymentConfirmationComponent; break;
            case 'PaymentUnicreditConfirmationComponent' : component = PaymentUnicreditConfirmationComponent; break;
            case 'PaymentNexiConfirmationComponent' : component = PaymentNexiConfirmationComponent; break;
            case 'PaymentBancaSellaConfirmationComponent' : component = PaymentBancaSellaConfirmationComponent; break;
            case 'OfflinePageComponent': component = OfflinePageComponent; break;
            case "NotFoundPageComponent": component = NotFoundPageComponent; break;
            case "SearchComponent": component = SearchComponent; break;
            case "NewsletterPageComponent": component = NewsletterPageComponent; break;
            case "NewsletterConfirmationPageComponent": component = NewsletterConfirmationPageComponent; break;   
            case "RegistrationConfirmationPageComponent": component = RegistrationConfirmationPageComponent; break;   
            case "QuickRegistrationComponent": component = QuickRegistrationComponent; break;                              
            default:
                component = null;
        }
        return component;
    }


    static getAllComponents() {
        return [
            HomeComponent,
            FaqComponent,
            ClientAreaHomeComponent,
            PrivacyPolicyComponent,
            CookiePolicyComponent,
            PurchaseConditionComponent,
            InfoRequestComponent,
            UserLoginComponent,
            UserPasswordComponent,
            RegisterComponent,
            CmsPageComponent,
            CategoryComponent,
            ProductDetailsComponent,
            ProductPageListComponent,
            PromotionsComponent,
            ArticleComponent,
            OtherProductComponent,
            BlogPageComponent,
            ArticleCategoryComponent,
            ClientAreaOrderListComponent,
            ClientAreaInvoicesComponent,
            ClientAreaProfileComponent,
            CartComponent,
            CartCashComponent,
            CartSubmittedComponent,
            CartEmptyPageComponent,
            ClientAreaOrderDetailsComponent,
            ClientAreaCatalogPrivateComponent,
            RegistrationConfirmationComponent,
            PaymentConfirmationComponent,
            PaymentUnicreditConfirmationComponent,
            PaymentNexiConfirmationComponent,
            PaymentBancaSellaConfirmationComponent,
            OfflinePageComponent,
            NotFoundPageComponent,
            SearchComponent,
            NewsletterPageComponent,
            NewsletterConfirmationPageComponent,
            RegistrationConfirmationPageComponent,
            QuickRegistrationComponent
        ];
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/system-configuration.service.ts